class ProductTabs extends HTMLElement {
    constructor() {
        super();

        this.tab = this.querySelectorAll('.tab-title');
        this.tabContents = this.querySelector('.tabs-contents');

        // 🔹 Si no existe el contenedor principal, detener ejecución
        if (!this.tabContents) return;

        this.tabContent = this.querySelectorAll('.tab-content');
        this.link = this.querySelectorAll('.toggleLink');
        this.readMore = this.querySelectorAll('[data-show-more-toogle]');
        this.tabClose = this.querySelectorAll('.pdViewTab-close');

        this.isVerticalPopup = this.dataset.vertical === 'sidebar';
        this.isVerticalSidebarMobile = this.dataset.verticalMobile === 'sidebar-mobile';

        // 🔹 Tabs click
        this.tab.forEach(tab => {
            tab.addEventListener('click', this.tabActive.bind(this));
        });

        // 🔹 Toggle links
        this.link.forEach(link => {
            link.addEventListener('click', this.tabToggle.bind(this));
        });

        // 🔹 Delegación de eventos
        document.addEventListener('click', e => {
            if (e.target.matches('[data-show-more-toogle]') || e.target.closest('[data-show-more-toogle]')) {
                this.readMoreReadLess(e);
            }
            else if (e.target.matches('.pdViewTab-close') || e.target.closest('.pdViewTab-close')) {
                this.productTabClose(e);

                if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
                    this.handleVerticalPopupClose(e);
                }
            }
        });

        // 🔹 Overlay
        if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
            const overlay = document.querySelector('.background-overlay');

            if (overlay) {
                overlay.addEventListener('click', this.onBackgroundClick.bind(this));
            }
        }

        // 🔹 Control show more description
        setTimeout(() => {
            if (window.innerWidth > 550) {
                const $thisContent = document.getElementById('tab-description-mobile');

                if (!$thisContent) return;

                const showMore = $thisContent.querySelector('.tab-showMore');
                if (!showMore) return;

                const tabHeight = $thisContent.offsetHeight;
                const maxHeight = parseInt(showMore.dataset.desMax);

                if (!isNaN(maxHeight) && tabHeight < maxHeight) {
                    showMore.remove();
                }
            }
        });

    }

    tabActive(event) {
        event.preventDefault();
        event.stopPropagation();

        const $this = event.target;
        const id = $this.getAttribute('href')?.replace('#', '');
        const button_tab = document.querySelector('.an-horizontal-shaking');

        if (!$this.classList.contains('is-open')) {

            this.tab.forEach(element => element.classList.remove('is-open'));

            $this.classList.add('is-open');
            this.tabContents.classList.add('is-show');

            button_tab?.classList.add('open-tab-content');

            this.tabContent.forEach(element => {
                if (element.getAttribute('id') === id) {
                    element.classList.add('is-active');
                } else {
                    element.classList.remove('is-active');
                }
            });
        }

        if ($this.classList.contains('open-tab-content')) {
            button_tab?.classList.remove('open-tab-content');
        }

        if (id) {
            this.checkTabShowMore(id);
        }
    }

    tabToggle(event) {
        event.preventDefault();
        event.stopPropagation();

        const $this = event.currentTarget;
        const $thisContent = $this.parentNode?.nextElementSibling;

        if (!$thisContent) return;

        if ($this.classList.contains('popup-mobile') && window.innerWidth <= 551) {

            if ($thisContent.classList.contains('is-show')) {
                $thisContent.classList.remove('is-show');
            } else {
                $thisContent.classList.add('is-show');
            }

        } else {

            if (window.innerWidth <= 551 && $this.classList.contains('show-mobile')) {

                $this.classList.remove('is-open');
                $this.classList.remove('show-mobile');
                $($thisContent).slideUp('slow');

            } else if ($this.classList.contains('is-open')) {

                $this.classList.remove('is-open');

                if ((this.isVerticalPopup && window.innerWidth > 550) || ($this.matches('.sidebar-mobile') && window.innerWidth <= 550)) {

                    $thisContent.classList.remove('is-show');
                    document.body.classList.remove('tab-popup-show');

                } else {

                    $($thisContent).slideUp('slow');

                }

            } else {

                $this.classList.add('is-open');

                if ((this.isVerticalPopup && window.innerWidth > 550) || ($this.classList.contains('sidebar-mobile') && window.innerWidth <= 550)) {

                    document.body.classList.add('tab-popup-sidebar-show');
                    $thisContent.classList.add('is-show');
                    document.body.classList.add('tab-popup-show');

                } else {

                    $($thisContent).slideDown('slow');

                }
            }
        }
    }

    readMoreReadLess(event) {
        event.preventDefault();
        event.stopPropagation();

        const $this = event.target.closest('[data-show-more-toogle]');
        if (!$this) return;

        const id = $this.getAttribute('href')?.replace('#', '');
        const textShowMore = $this.getAttribute('data-show-more-text');
        const textShowLess = $this.getAttribute('data-show-less-text');

        const wrapper = $this.closest('.tab-showMore');
        if (!wrapper) return;

        const desMax = wrapper.dataset.desMax;

        const content = document.getElementById(id);
        if (!content) return;

        if ($this.classList.contains('is-less')) {

            wrapper.classList.remove('is-less');
            $this.classList.remove('is-less');

            wrapper.classList.add('is-show');
            $this.classList.add('is-show');

            $this.innerText = textShowMore;

            content.style.maxHeight = `${desMax}px`;

            this.tabContents?.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });

        } else {

            wrapper.classList.remove('is-show');
            $this.classList.remove('is-show');

            wrapper.classList.add('is-less');
            $this.classList.add('is-less');

            $this.innerText = textShowLess;

            content.style.maxHeight = 'unset';
        }
    }

    productTabClose(event) {
        event.preventDefault();
        event.stopPropagation();

        this.tabContents?.classList.remove('is-show');

        this.tab.forEach(element => {
            element.classList.remove('is-open');
        });

        this.tabContent.forEach(element => {
            element.classList.remove('is-active');
        });

        document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');

        if (window.innerWidth <= 551) {

            const $toggleContent = event.target.closest('.toggle-content');

            if ($toggleContent) {
                $toggleContent.classList.remove('is-show');
            }
        }
    }

    checkTabShowMore(id) {

        if (window.innerWidth > 550) {

            const $thisContent = document.getElementById(id);
            if (!$thisContent) return;

            const showMore = $thisContent.querySelector('.tab-showMore');
            if (!showMore) return;

            const tabHeight = $thisContent.offsetHeight;
            const maxHeight = parseInt(showMore.dataset.desMax);

            if (!isNaN(maxHeight) && tabHeight < maxHeight) {
                showMore.remove();
            }
        }
    }

    onBackgroundClick(event) {

        if (event.target.closest('.toggle-content.is-show') != null) return;

        document.querySelector('.toggleLink.is-open')?.classList.remove('is-open');
        document.querySelector('.toggle-content.is-show')?.classList.remove('is-show');

        document.body.classList.remove('tab-popup-show');
    }

    handleVerticalPopupClose(event) {

        const icon = event.target;

        const toggleContent = icon.closest('.toggle-content');
        if (!toggleContent) return;

        toggleContent.classList.remove('is-show');

        const tabContent = icon.closest('.tab-content');
        const toggleLink = tabContent?.querySelector('.toggleLink');

        toggleLink?.classList.remove('is-open');

        document.body.classList.remove('tab-popup-show');
    }
}

customElements.define('product-tab', ProductTabs);